// extracted by mini-css-extract-plugin
module.exports = {"ads":"Ads_ads__2z8Aj","adsWrapper":"Ads_adsWrapper__1ANjV"};